export { default as Tabs } from './Tabs';
export { default as TabPanel } from './TabPanel';
export { default as Tab } from './Tab';



// WEBPACK FOOTER //
// ./src/components/Tabs/index.js